const ua = {
    common: {
        history: "історична версія"
    }
};
export default ua;



// WEBPACK FOOTER //
// ./src/i18n/langs/ua.js